import { render, staticRenderFns } from "./RecentActivityTableDescriptionBookingCancelled.vue?vue&type=template&id=a0f91dd6&"
import script from "./RecentActivityTableDescriptionBookingCancelled.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionBookingCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports